export default "__VITE_ASSET__I0rR98n9__";